module.exports = __webpack_public_path__ + "img/jf5.6cc96ddd.png";